import findLast from "lodash/findLast";

export default {
  getId: (state) => {
    const { id = 0 } =
      findLast(state.languageList, { lang_key: state.key }) || {};
    return id;
  },
};
